import { Box, Grid, List, ListItem, Typography, styled } from "@mui/material";

import NumberFormats from "components/NumberFormats";
import React from "react";
import { TYPES } from "pages/Deposit/constants";
import { useFormContext } from "react-hook-form";

export function DepositExtraInfo({ selectedWallet, selectedCoin }) {
  const { watch } = useFormContext();
  const isDigital = watch("isDigital");
  const type = watch("type");

  return (
    <>
      {!selectedWallet && (
        <Grid item xs={12}>
          <BoxResult>
            {type !== TYPES.internal && (
              <>
                <Typography color="text.secondary" component="h6">
                  {isDigital && (
                    <>
                      {type === TYPES.core ? (
                        <>حداقل مقدار واریز: </>
                      ) : (
                        <>مقدار واریز: </>
                      )}
                    </>
                  )}
                  {!isDigital && (
                    <>
                      {type === TYPES.internal ? (
                        <>مقدار واریز: </>
                      ) : (
                        <>حداقل مقدار واریز: </>
                      )}
                    </>
                  )}
                  <Typography
                    color="text.main"
                    component="span"
                    fontWeight={600}
                  >
                    <NumberFormats
                      value={selectedWallet?.minimumDepositAmount}
                    />
                  </Typography>
                </Typography>
              </>
            )}

            <Typography component="h6" color="text.secondary">
              کارمزد واریز:{" "}
              <Typography component="span" color="text.main" fontWeight={600}>
                <NumberFormats value={selectedWallet?.depositFeeAmount} />
              </Typography>
            </Typography>
          </BoxResult>

          {type === TYPES.core && (
            <BoxCore>
              <List>
                <ListItem>
                  • Send only{" "}
                  <Typography component="span" fontWeight={600}>
                    {selectedCoin?.name}
                  </Typography>{" "}
                  to this deposit address
                  <br /> (تنها از
                  <Typography component="span" fontWeight={600} px={0.3}>
                    {selectedCoin?.name}
                  </Typography>{" "}
                  برای واریز کردن به این آدرس استفاده کنید)
                </ListItem>
                <ListItem>
                  • Ensure the network is{" "}
                  <Typography
                    component="span"
                    fontWeight={600}
                    color="error.main"
                  >
                    {selectedCoin?.name}
                    <br />
                  </Typography>{" "}
                  (از درست بودن شبکه{" "}
                  <Typography
                    component="span"
                    fontWeight={600}
                    color="error.main"
                  >
                    {selectedCoin?.name}
                  </Typography>{" "}
                  اطمینان حاصل کنید)
                </ListItem>
              </List>
            </BoxCore>
          )}
        </Grid>
      )}
    </>
  );
}

const BoxResult = styled(Box)(({ theme }) => ({
  direction: "rtl",
  textAlign: "right",
  margin: theme.spacing(1, 0),
  color: theme.palette.text.main,
  ".MuiTypography-root": {
    fontSize: "14px",
  },
}));

const BoxCore = styled(Box)(({ theme }) => ({
  background: theme.palette.background.primaryGradient,
  boxShadow: "none",
  borderRadius: "10px",
  direction: "rtl",
  textAlign: "right",
  ul: {
    li: {
      textAlign: "right",
      color: theme.palette.text.main,
      display: "block",
    },
  },
}));
export default DepositExtraInfo;
